import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.cuenta.empresas.upsert.data = { ...data };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.cuenta.empresas.upsert = { ...state.cuenta.empresas.upsert, ...data };
  });
};

const upsert = async (store, data, id) => {
  store.setState((state) => {
    state.cuenta.empresas.upsert.busy = true;
  });

  try {
    let response;

    if (!id) {
      response = await Http.post(`api/empresas`, data);
    } else {
      response = await Http.put(`api/empresas/${id}`, data);
    }

    store.setState((state) => {
      state.cuenta.empresas.upsert.result = response;
      state.cuenta.empresas.upsert.busy = false;
    });

    return response;
  } catch (error) {
    store.setState((state) => {
      state.cuenta.empresas.upsert.error = error.data || error;
      state.cuenta.empresas.upsert.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.cuenta.empresas.upsert.error = undefined;
};

const reset = (store) => (state) => {
  state.cuenta.empresas.upsert = { ...initialState };
};

const actions = {
  setData,
  change,
  upsert,
  resetError,
  reset,
};

const EmpresasUpsertStore = {
  state: () => initialState,
  actions,
};

export default EmpresasUpsertStore;
